/* 

  Define time constants

*/

export const HOUR_IN_SECONDS = 3600;
export const HOUR_IN_MILLIS = HOUR_IN_SECONDS * 1000;

export const DAY_IN_SECONDS = HOUR_IN_SECONDS * 24;
export const DAY_IN_MILLIS = DAY_IN_SECONDS * 1000;

export const MINUTE_IN_SECONDS = 60;
export const MINUTE_IN_MILLIS = 1000 * 60;
//const DAY_IN_MILLIS = 86400000;

/* 

  Cart settings

*/

// quantity input field maxlenth
export const CART_QTY_MAXLENGTH = 6;
export const CART_QTY_MAXVALUE = 9999;

/* 

  Toast message settings

*/

// quantity input field maxlenth
export const TOAST_DELAY_MILLIS = 3500;

/* 

  Slider settings

*/

// Slider of product tiles: Start autoplay slider
export const SWIPER_SLIDER_AUTOPLAY = false;
export const SWIPER_SLIDER_AUTOPLAY_DELAY = 2500;
